/** @format */

export const actionTypes = {
  GET_PROFILE_REQUEST: 'Registration/GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS: 'Registration/GET_PROFILE_SUCCESS',
  GET_PROFILE_ERROR: 'Registration/GET_PROFILE_ERROR',
}

export const getProfile = {
  request: () => ({
    type: actionTypes.GET_PROFILE_REQUEST,
  }),
  success: (payload) => ({
    type: actionTypes.GET_PROFILE_SUCCESS,
    payload,
  }),
  error: (error) => ({
    type: actionTypes.GET_PROFILE_ERROR,
    error,
  }),
}
